import { SxProps } from "@mui/system";
import { ThemeV2 } from "../util/types";

export const getInputStyles = (theme: ThemeV2): SxProps => ({
  backgroundColor: theme.tokens.color.surface.card,
  borderRadius: `${theme.tokens.shape.radius.md}px`,
  color: theme.tokens.color.text.primary,
});
